import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Newspaper } from 'lucide-react';
import heroBg from '../assets/auth/logistics-hero.png';
import '../styles/news-page.css';

const News = () => {
  return (
    <div className="news-page">
      <section className="news-hero" aria-labelledby="news-hero-title">
        <div className="news-hero__bg" style={{ backgroundImage: `url(${heroBg})` }} />
        <div className="news-hero__overlay" />
        <div className="news-hero__inner">
          <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.45 }}>
            <p className="news-hero__crumb">
              <Link to="/">Home</Link>
              <span aria-hidden> &gt; </span>
              News
            </p>
            <h1 id="news-hero-title" className="news-hero__title">
              News &amp; updates
            </h1>
            <p className="news-hero__lead">
              Announcements, route news, and logistics stories from Jet Shipping Cargo.
            </p>
          </motion.div>
        </div>
      </section>

      <div className="news-shell">
        <motion.div
          className="news-card"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1, duration: 0.45 }}
        >
          <Newspaper className="w-14 h-14" strokeWidth={1.75} aria-hidden />
          <p>
            Our news section is being updated. Check back soon for the latest on routes, partnerships, and logistics
            insights.
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default News;
